import { render, staticRenderFns } from "./TechnicalSkillsSection.vue?vue&type=template&id=f2e52332&scoped=true"
import script from "./TechnicalSkillsSection.vue?vue&type=script&lang=js"
export * from "./TechnicalSkillsSection.vue?vue&type=script&lang=js"
import style0 from "./TechnicalSkillsSection.vue?vue&type=style&index=0&id=f2e52332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e52332",
  null
  
)

export default component.exports